import ArcadeSeriesBadge from '@/components/Badge/ArcadeSeriesBadge'
import { ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH } from '../../../constants'
import ArcadePointValuesGrid from './ArcadePointValuesGrid'
import { RARITY_TYPES } from '@/enum'
import RarityBadge from '@/components/RarityBadge'
import ArcadeOverviewConvertEligibility from '../ArcadeOverviewConvertEligibility'
import { MergedSeason } from '@/features/arcade/types'
import PinElements from '@/components/PinElements'
import CloudinaryImage from '@/components/CloudinaryImage'
import { OVERVIEW_PAGE_SECTION_ID } from '@/features/arcade/hooks/routing'

// @todo - stevei - make this dynamic. this is a hardcoded placeholder until a schema is known from the BE
const pointsData = [
  {
    badge: (
      <RarityBadge
        rarity={RARITY_TYPES['1 of 1']}
        size="lg"
        redeemable={false}
      />
    ),
    points: '100,000'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Mythic} size="lg" redeemable={false} />
    ),
    points: '2,000'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Grail} size="lg" redeemable={false} />
    ),
    points: '1,000'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Royalty} size="lg" redeemable={false} />
    ),
    points: '500'
  },
  {
    badge: (
      <RarityBadge
        rarity={RARITY_TYPES.Legendary}
        size="lg"
        redeemable={false}
      />
    ),
    points: '250'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Series} size="lg" redeemable={false} />
    ),
    points: '200'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Ultra} size="lg" redeemable={false} />
    ),
    points: '80'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Epic} size="lg" redeemable={false} />
    ),
    points: '50'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Rare} size="lg" redeemable={false} />
    ),
    points: '16'
  },
  {
    badge: (
      <RarityBadge
        rarity={RARITY_TYPES.Uncommon}
        size="lg"
        redeemable={false}
      />
    ),
    points: '10'
  },
  {
    badge: (
      <RarityBadge rarity={RARITY_TYPES.Common} size="lg" redeemable={false} />
    ),
    points: '8'
  }
]

const ArcadeOverviewPointValues = ({
  season,
  offSeason = false
}: {
  season: MergedSeason
  offSeason?: boolean
}) => {
  const title = offSeason ? 'Points Values coming soon' : 'Arcade Point Values'
  const description = offSeason
    ? 'Stay tuned! Next season’s point values will be released soon.'
    : 'Each rarity has a specific point value, which is added to your score upon conversion.'
  return (
    <div className="container flex flex-col items-center max-w-[752px] [&>*:not(:first-child)]:pt-8">
      <PinElements
        className="w-full"
        pins={{
          className: 'max-lg:hidden z-10',
          items: [
            {
              element: (
                <CloudinaryImage
                  imageId={'esoteric_l'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={223}
                  height={239}
                />
              ),
              anchor: {
                x: 100,
                y: 0
              },
              position: {
                x: -14,
                y: -55
              }
            },
            {
              element: (
                <CloudinaryImage
                  imageId={'esoteric_r'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={200}
                  height={314}
                />
              ),
              anchor: {
                x: 0,
                y: 0
              },
              position: {
                x: 122,
                y: 79
              }
            }
          ]
        }}
      >
        <div className="flex flex-col items-center w-full gap-2">
          <ArcadeSeriesBadge label={`Season ${season.id}`} size="lg" />
          <h3 className="h3 text-center">{title}</h3>
          <p className="body-lg text-gray-300 text-center">{description}</p>
        </div>
      </PinElements>
      <PinElements
        className="w-full"
        pins={{
          className: 'max-lg:hidden z-10',
          items: [
            {
              element: (
                <CloudinaryImage
                  imageId={'star_lightning'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={292}
                  height={376}
                />
              ),
              anchor: {
                x: 100,
                y: 0
              },
              position: {
                x: -10,
                y: 66
              }
            },
            {
              element: (
                <CloudinaryImage
                  imageId={'blue_tongue'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={265}
                  height={385}
                />
              ),
              anchor: {
                x: 0,
                y: 0
              },
              position: {
                x: 121,
                y: 91
              }
            }
          ]
        }}
      >
        <ArcadePointValuesGrid pointsData={pointsData} offSeason={offSeason} />
      </PinElements>
      <div id={OVERVIEW_PAGE_SECTION_ID.CONVERT}>
        <ArcadeOverviewConvertEligibility />
      </div>
    </div>
  )
}

export default ArcadeOverviewPointValues
